// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6a975c17","455":"5c32314f","977":"3f293a12"}[chunkId] + ".chunk.js";
};